const modules = import.meta.glob('../assets/images/**/*.{png,jpg,jpeg,gif,svg}', {
  eager: true,
  import: 'default'
});

const images: Record<string, string> = {};

Object.entries(modules).forEach(([path, url]) => {
  const imageName = path.replace('../assets/images/', '');
  images[imageName] = url as string;
});

export default images;
